var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M24 11.833C24 5.297 18.628 0 12 0S0 5.297 0 11.833c0 5.908 4.388 10.803 10.125 11.69v-8.269H7.078v-3.42h3.047V9.225c0-2.965 1.79-4.604 4.533-4.604 1.312 0 2.686.232 2.686.232v2.912H15.83c-1.49 0-1.955.913-1.955 1.849v2.218h3.328l-.532 3.421h-2.796v8.27C19.613 22.636 24 17.74 24 11.834z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h24v23.667H0z"})))]);
}

Facebook.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
